import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShoppingCart, Lock } from 'lucide-react';
export function Donation() {
  return <section id="donate" className="py-20 lg:py-28 bg-usa-gray" data-id="element-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-11">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start" data-id="element-12">
          {/* LEFT: Copy */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="lg:col-span-5" data-id="element-13">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-usa-navy mb-6 leading-tight" data-id="element-14">
              HELP FUND <span className="text-usa-red" data-id="element-15">THE JOURNEY</span>
            </h2>
            <div className="w-16 h-1 bg-usa-red mb-8" data-id="element-16" />

            <p className="text-xl text-gray-800 font-semibold mb-3" data-id="element-17">
              100% of funds go directly toward Cyrus's athlete journey.
            </p>
            <p className="text-lg text-gray-600 mb-8" data-id="element-18">
              Your support makes high-level competition possible.
            </p>

            <div className="bg-white p-6 border-l-4 border-usa-navy" data-id="element-19">
              <h3 className="font-display text-xl text-usa-navy tracking-wide mb-4" data-id="element-20">
                Donations help cover:
              </h3>
              <div className="space-y-3" data-id="element-21">
                {['Tournament entry fees', 'Travel expenses (flights and hotels)', 'Training costs and seminars', 'Protective equipment and gear', 'National and world-level competition opportunities'].map((item, i) => <div key={i} className="flex items-start gap-3 text-gray-700" data-id="element-22">
                    <CheckCircle2 className="text-usa-red shrink-0 mt-0.5" size={18} data-id="element-23" />
                    <span data-id="element-24">{item}</span>
                  </div>)}
              </div>
            </div>
          </motion.div>

          {/* RIGHT: Two donation cards with OR divider */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="lg:col-span-7" data-id="element-25">
            <div className="relative grid md:grid-cols-2 gap-6 md:gap-4" data-id="element-26">
              {/* CARD 1: Preset Amount */}
              <div className="bg-white shadow-xl border-t-4 border-usa-red p-6 md:p-8 flex flex-col" data-id="element-27">
                <div className="mb-4" data-id="element-28">
                  <span className="inline-block text-xs font-bold text-usa-red uppercase tracking-widest mb-2" data-id="element-29">
                    Option 1
                  </span>
                  <h3 className="font-display text-2xl text-usa-navy tracking-wide mb-2" data-id="element-30">
                    Choose a Preset Amount
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-31">
                    Select a preset donation amount and continue to checkout.
                  </p>
                </div>

                {/* Ecommerce module placeholder */}
                <div className="flex-grow flex flex-col" data-id="element-32">
                  <div className="bg-usa-gray border-2 border-dashed border-gray-300 p-5 mb-4 flex-grow" data-id="element-33">
                    <div className="text-center text-xs uppercase tracking-widest text-gray-500 font-bold mb-3" data-id="element-34">
                      [ Preset Donation Product Module ]
                    </div>
                    {/* Visual preview of selector — actual module will replace this */}
                    <label className="block text-xs font-semibold text-gray-700 uppercase tracking-wide mb-2" data-id="element-35">
                      Select amount
                    </label>
                    <div className="relative" data-id="element-36">
                      <select className="w-full appearance-none bg-white border border-gray-300 px-4 py-3 pr-10 text-gray-700 font-medium focus:outline-none focus:border-usa-navy" aria-label="Preset donation amount" data-id="element-37">
                        <option data-id="element-38">$10</option>
                        <option data-id="element-39">$25</option>
                        <option data-id="element-40">$50</option>
                        <option data-id="element-41">$100</option>
                        <option data-id="element-42">$500</option>
                      </select>
                      <div className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" data-id="element-43">
                        ▾
                      </div>
                    </div>
                  </div>

                  <button className="w-full bg-usa-red hover:bg-red-700 text-white font-display text-lg py-4 tracking-wider transition-colors flex items-center justify-center gap-2" data-id="element-44">
                    <ShoppingCart size={18} data-id="element-45" />
                    Make Donation
                  </button>
                </div>
              </div>

              {/* OR Divider */}
              <div aria-hidden="true" className="md:absolute md:inset-y-0 md:left-1/2 md:-translate-x-1/2 flex md:flex-col items-center justify-center gap-3 md:gap-0 my-2 md:my-0 z-10" data-id="element-46">
                <div className="flex-grow md:flex-grow md:w-px h-px md:h-full bg-gray-300" data-id="element-47" />
                <div className="bg-usa-navy text-white font-display text-sm tracking-widest w-12 h-12 rounded-full flex items-center justify-center shadow-md shrink-0" data-id="element-48">
                  OR
                </div>
                <div className="flex-grow md:flex-grow md:w-px h-px md:h-full bg-gray-300" data-id="element-49" />
              </div>

              {/* CARD 2: Custom Amount */}
              <div className="bg-white shadow-xl border-t-4 border-usa-navy p-6 md:p-8 flex flex-col" data-id="element-50">
                <div className="mb-4" data-id="element-51">
                  <span className="inline-block text-xs font-bold text-usa-navy uppercase tracking-widest mb-2" data-id="element-52">
                    Option 2
                  </span>
                  <h3 className="font-display text-2xl text-usa-navy tracking-wide mb-2" data-id="element-53">
                    Enter a Custom Amount
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-54">
                    Choose the amount you would like to contribute.
                  </p>
                </div>

                {/* Ecommerce module placeholder */}
                <div className="flex-grow flex flex-col" data-id="element-55">
                  <div className="bg-usa-gray border-2 border-dashed border-gray-300 p-5 mb-4 flex-grow" data-id="element-56">
                    <div className="text-center text-xs uppercase tracking-widest text-gray-500 font-bold mb-3" data-id="element-57">
                      [ Custom Donation Product Module ]
                    </div>
                    <label className="block text-xs font-semibold text-gray-700 uppercase tracking-wide mb-2" data-id="element-58">
                      Donation amount
                    </label>
                    <div className="relative" data-id="element-59">
                      <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500 font-medium" data-id="element-60">
                        $
                      </span>
                      <input type="number" placeholder="0.00" className="w-full pl-8 pr-4 py-3 bg-white border border-gray-300 text-gray-700 font-medium focus:outline-none focus:border-usa-navy" aria-label="Custom donation amount" data-id="element-61" />
                    </div>
                  </div>

                  <button className="w-full bg-usa-navy hover:bg-gray-900 text-white font-display text-lg py-4 tracking-wider transition-colors flex items-center justify-center gap-2" data-id="element-62">
                    <ShoppingCart size={18} data-id="element-63" />
                    Make Donation
                  </button>
                </div>
              </div>
            </div>

            {/* Secure checkout note */}
            <div className="flex items-center justify-center gap-2 mt-6 text-sm text-gray-600" data-id="element-64">
              <Lock size={14} data-id="element-65" />
              <span data-id="element-66">Secure checkout / payment processing</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}